import React, { useContext } from "react";
// Componentes
import ComponentTable from "./ComponentsTable";
import Icon from "./Icon";
// Images
import deleteIcon from "../../assets/delete.png";
import downloadIcon from "../../assets/download.png";
// Contexto
import { ConfirmModalContext } from "../../context/confirmModalContext";

const TablaDocumentos = ({ misionDocumentos, handleDownloadDocumento, handleDeleteMisionDocumento }) => {
  // Ventana de confirmación
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);

  const getDescription = (row) => {
    return <p className="text-truncate">{row.description}</p>;
  };

  // Gestiona la acción que se realiza cuando damos en la imagen de eliminar cargo
  const deleteDocumento = (row) => {
    return (
      <Icon
        src={deleteIcon}
        onClick={() => {
          {
            confirmModalSetTitle(`Eliminar el documento ${row.name}`);
            confirmModalSetContent(<p> {`¿Está seguro de que quiere eliminar el documento?`} </p>);
            confirmModalSetFunction(() => {
              handleDeleteMisionDocumento(row.id);
            });
            confirmModalSetShow(true);
          }
        }}
        className="d-flex m-auto"
      />
    );
  };

  // Gestiona la descaga del documento
  const downloadDocumento = (row) => {
    return (
      <Icon
        src={downloadIcon}
        onClick={() => {
          handleDownloadDocumento(row);
        }}
        className="d-flex m-auto"
      />
    );
  };

  return (
    <ComponentTable
      emptyTableComponent={<p className="m-2">{`No se han encontrado documentos`}</p>}
      headers={[
        { name: "Nombre", value: "name" },
        { name: "Categoria", value: "category" },
        { name: "Descripción", value: getDescription, style: { maxWidth: "25px" } },
        { name: "Descargar", value: downloadDocumento, style: { width: 15 } },
        { name: "Eliminar", value: deleteDocumento, style: { width: 15 } },
      ]}
      rows={misionDocumentos}
    />
  );
};

export default TablaDocumentos;
